import data from "./options.json";

const getMappedOptions = (options) =>
  options.map((item) => ({ label: item, value: item }));

export const getProductNameOptions = () =>
  getMappedOptions(data.products || []);

export const getCauseOptions = () => getMappedOptions(data.cause || []);

export const getCustomerActionOptions = () =>
  getMappedOptions(data["customer action"] || []);

export const getComplaintOptions = (productName = "") => {
  productName ||= "";
  return getMappedOptions(data.complaint[productName] || []);
};

export const getItemPossessionStatusOptions = () =>
  getMappedOptions(data["item possession status"] || []);
